// client/src/App.js

import "../App.css";
import CommonContext from '../commonContext';
import React, { Component, useEffect, useState } from 'react';
import { customColors } from '../utils/customColors';
import {
  AlertDialog,
  AlertDialogBody, AlertDialogContent, AlertDialogFooter,
  AlertDialogHeader, AlertDialogOverlay, Button, FormControl,
  Input, useToast, Box, Text,
  Center,
  FormLabel,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Stack,
  IconButton,
  Flex,
  Table,
  Thead,
  Tbody,
  Tfoot,
  Tr,
  Th,
  Td,
  Progress,
  TableCaption,
  Spinner,
  AbsoluteCenter,
  TableContainer,
  Checkbox,
  CheckboxGroup,
  Textarea,
  StepDescription,
  Select,
  HStack,
  VStack,
  Divider
} from '@chakra-ui/react';
import { BiArrowBack } from "react-icons/bi";
import { AiFillStepBackward, AiFillStepForward } from "react-icons/ai";
import { MdDelete, MdEdit, MdAdd } from "react-icons/md";
import { IoMdArrowRoundBack } from "react-icons/io";
import { postCall } from '../utils/requests';
import Utils from '../utils/utils';
import { decode } from "punycode";
import axios from "axios";

function HomeTile({ icon, title, content, onClick, height = "350px", width = "600px", bg = "blue.200", borderRadius = "lg", shadow = "lg", mb = "0px", ml = "0px", mt = "0px", mr = "0px" }) {

  const commonContext = React.useContext(CommonContext);

  /* utils */
  const toast = useToast();





  return (
    <Box mr={mr} ml={ml} mt={mt} mb={mb} w={width} h={height} bg={bg} borderRadius={borderRadius} shadow={shadow}>
      <Flex h="100%">
        <Center w="100%">
          <VStack w="100%" alignItems="center" h="100%">
            <Flex justifyContent="space-between" h="20%" w="100%">
              <Center
                mt="5px"
                mb="10px"
                h="100%"
                pl="30px"
                textAlign="left">
                {icon}
              </Center>
              <Center
                w="100%"
                h="100%"
                pr="50px"
                mt="5px"
                mb="10px"
              >
                <Text
                  textAlign="center"
                  fontSize="2xl"
                  fontWeight="bold"
                  flex="1"
                >
                  {title}
                </Text></Center>
            </Flex>
            <Divider w="90%"></Divider>
            {content}
          </VStack>
        </Center>

      </Flex>
    </Box>


  );

}

export default HomeTile;